import { ReactComponent as Icon } from "../images/registered-user.svg";

const RegisteredUserIcon = ({ size = "120", color = "#5EC394" }) => {
  return (
    <>
      <Icon width={size} height={size} fill={color} />
    </>
  );
};
export default RegisteredUserIcon;